import React, { useState } from 'react';
import classNames from 'classnames';
import {
  Settings,
  Tool,
  Tag,
  Image,
  Target,
  Calendar,
  Link,
  Layers,
  BookOpen,
  Zap,
  HelpCircle,
  LogOut,
} from 'react-feather';
import { routes } from 'constants/config';
import ActionList from 'ui/ActionList';
import Popover from 'ui/Popover';

const CogMenu = ({ anonUniversityLoginUrl, meta, navbarCollapsed }) => {
  const { currentUser, features, permissions, locale } = meta;
  const {
    canEditOrViewSettings,
    canViewTags,
    canViewImageGallery,
    canViewTriggers,
    canCreateAssignments,
    canViewRelatedUrls,
    canCreateUsers,
  } = permissions;

  const [isOpen, setIsOpen] = useState(false);

  const isCurrentUserLearner = currentUser.role === 'learner';
  const isIframedInSeismic = sessionStorage.getItem('iframedInSeismic');

  return (
    <li>
      <Popover
        activator={
          <button
            type="button"
            aria-label={t('settings.title')}
            className={classNames(
              'CogMenuToggle',
              isOpen ? 'c-midnight-100' : 'c-midnight-50',
            )}
            onClick={() => setIsOpen(!isOpen)}
          >
            <Settings />
          </button>
        }
        align={locale.direction === 'rtl' ? 'left' : 'right'}
        className={classNames('CogMenu', { mobileDisplay: navbarCollapsed })}
        visible={isOpen}
        onClose={() => setIsOpen(false)}
        onSelect={() => setIsOpen(false)}
      >
        <ActionList
          items={[
            canEditOrViewSettings && {
              content: t('settings.title'),
              FeatherIcon: Tool,
              url: routes.SETTINGS.INDEX,
            },
            canViewTags && {
              content: t('tags.title'),
              FeatherIcon: Tag,
              url: routes.TAGS,
            },
            canViewImageGallery && {
              content: t('image_library.title'),
              FeatherIcon: Image,
              url: routes.IMAGES,
            },
            canViewTriggers && {
              content: t('triggers.title'),
              FeatherIcon: Target,
              url: routes.TRIGGERS.INDEX,
            },
            features.scheduled_assignments &&
              canCreateAssignments && {
                content: t('scheduled_assignments.title'),
                FeatherIcon: Calendar,
                url: routes.SCHEDULED_ASSIGNMENTS,
              },
            features.related_urls &&
              canViewRelatedUrls && {
                content: t('related_urls.title'),
                FeatherIcon: Link,
                url: routes.RELATED_URLS,
              },
            features.web_widget &&
              canViewRelatedUrls && {
                content: t('web_widget.title'),
                FeatherIcon: Link,
                url: routes.WEB_WIDGETS,
              },
            canCreateUsers && {
              content: t('user_imports.title'),
              FeatherIcon: Layers,
              url: routes.NEW_BULK_IMPORT,
            },
            anonUniversityLoginUrl && {
              content: t('university_anonymous_login.title'),
              FeatherIcon: BookOpen,
              url: anonUniversityLoginUrl,
              openInNewTab: true,
            },
            !isCurrentUserLearner && {
              content: t('product_board.title'),
              FeatherIcon: Zap,
              url: 'https://portal.productboard.com/xht2xgpp23ecjbwsuzhb3nie',
              openInNewTab: true,
            },
            !isCurrentUserLearner && {
              content: t('help_center.title'),
              FeatherIcon: HelpCircle,
              url: 'https://intercom.help/lessonly/en/',
              openInNewTab: true,
            },
            !isIframedInSeismic && {
              content: t('sessions.end', { name: currentUser.name }),
              FeatherIcon: LogOut,
              url: routes.SIGNOUT,
            },
          ]}
        />
      </Popover>
    </li>
  );
};

export default props => <CogMenu {...props} />;
